export default "__VITE_ASSET__DKYMYksp__"